// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pwWr","left":"styles_left__1dau4","desktopActions":"styles_desktopActions__3NiYe","title":"styles_title__h4m2z"};